<template>
    <v-container class="email-notifications">

        <h2>Email Notifications</h2>

        <v-checkbox
            v-model="localReceive"
            label="Receive Notifications"
            hideDetails
        />

        <v-checkbox
            v-model="localReminder"
            label="Reminder Notifications"
            hideDetails
        />

        <ClButton
            aria-label="Update Email Notification Settings"
            class="button-update"
            :rounded="false"
            @click="updateSettings()"
        >
            Update Email Notifications
        </ClButton>
    </v-container>
</template>

<script>
// Vuex
import { mapState } from 'vuex';

export default {
    name: 'EmailNotifications',
    data() {
        return {
            localReceive: null,
            localReminder: null,
        };
    },
    computed: {
        ...mapState( {
            receive: ( state ) => state.Mail.Settings.notifications.receive,
            reminder: ( state ) => state.Mail.Settings.notifications.reminder,
        } ),
    },
    watch: {
        receive: {
            immediate: true,
            handler() {
                this.localReceive = this.receive;
            },
        },
        reminder: {
            immediate: true,
            handler() {
                this.localReminder = this.reminder;
            },
        },
    },
    methods: {
        async updateSettings() {
            await this.$store.dispatch( 'Mail/Settings/update', {
                sendReceiveEmailNotification: this.localReceive,
                sendReminderEmailNotification: this.localReminder,
            } );
        },
    },
};
</script>

<style lang="scss">
.email-notifications {
    .button-update {
        margin-top: 1rem;
        width: 100%;
    }
}
@include mixins-above(tablet) {
    .email-notifications {
        .button-update {
            width: auto;
        }
    }
}
</style>
